// Formata centavos (inteiro) na moeda/locale do restaurante.
export function formatMoney(cents: number, currency: string, locale: string): string {
  try {
    return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
  } catch {
    return (cents / 100).toFixed(2);
  }
}

// centavos a partir de um texto digitado ("59,90" ou "59.90")
export function parseMoneyToCents(input: string): number {
  const normalized = input.replace(/\./g, '').replace(',', '.');
  const value = Number.parseFloat(normalized.replace(/[^0-9.]/g, ''));
  if (Number.isNaN(value)) return 0;
  return Math.round(value * 100);
}

// pega o texto i18n no idioma atual, com fallbacks
export function pickLocale(
  value: Record<string, string> | null | undefined,
  locale: string,
  fallback = 'pt-BR'
): string {
  if (!value) return '';
  return value[locale] || value[fallback] || Object.values(value)[0] || '';
}
